import { createSlice } from '@reduxjs/toolkit';
import { mergeArrayByKey, sortArrayByKey, formatEpochWithTimezone, formatEpochAsShortDateTime } from '../../common/util';
import {
  RESET_WORKKARD_DETAIL_DATA,
  ACTIVITY_LISTING_SUCCESS,
  ACTIVITY_LISTING_ERROR,
  SET_ACTIVITY_ID,
  UPDATE_ACTIVITY_LISTING_SUCCESS,
  SHOW_LISITNG_LOADER,
  HIDE_LISITNG_LOADER,
  UPDATE_ACTIVITY_STATUS_SUCCESS,
  EDIT_ACTIVITY_DATA_SUCCESS,
  CLOSE_ACTIVITY_LISTING_SUCCESS,
  CLEAR_CLOSE_ACTIVITIES,
  ACTIVITY_DETAIL_DATA_SUCCESS,
  ACTIVITY_DETAIL_DATA_ERROR,
  ACTIVITY_DETAIL_FULL_REPLACE,
  FETCH_ACTIVITY_TEMPLATES_LIST_SUCCESS,
  SET_REOPEN_REASON_LIST,
  FETCH_MIDDLE_PANEL_DATA_SUCCESS,
  FETCH_MIDDLE_PANEL_FILTER_SUCCESS,
  FETCH_MIDDLE_PANEL_NOTES_SUCCESS,
  UPDATE_MIDDLE_PANEL_NOTES_SUCCESS,
  NOTES_ACTION_PUBLISH_SUCCESS,
  REMOVE_EDITED_NOTE,
  FETCH_MIDDLE_PANEL_FILE_SUCCESS,
  FETCH_MIDDLE_PANEL_LOG_SUCCESS,
  UPDATE_MIDDLE_PANEL_LOG_SUCCESS,
  FETCH_MIDDLE_PANEL_DIARIES_SUCCESS,
  FETCH_MIDDLE_PANEL_PARTIES_SUCCESS,
  UPDATE_MIDDLE_PANEL_PARTIES_SUCCESS,
  RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS,
  UPDATE_CAPTION_SUCCESS,
  RESET_MIDDLE_PANEL_INDIVIDUAL_TAB_SUCCESS,
  UPDATE_ACTIVITY_EXCLUDED_FILTER,
  WORKKARD_TODO_OWNERS_SUCCESS,
  DIARIES_TITLE_EDIT_SUCCESS,
  DIARIES_DUE_DATE_EDIT_SUCCESS,
  DIARIES_ACTION_COMPLETE_SUCCESS,
  DIARIES_ACTION_CANCELLED_SUCCESS,
  IS_LARGE_VIEW_ACTIVE,
  IS_SELECT_ALL,
  FETCH_MIDDLE_PANEL_NOTES_ERROR,
  FETCH_MIDDLE_PANEL_FILE_ERROR,
  FETCH_MIDDLE_PANEL_DIARIES_ERROR,
  FETCH_MIDDLE_PANEL_LOG_ERROR,
  FETCH_MIDDLE_PANEL_PARTIES_ERROR,
  NOTES_ACTION_DELETE_SUCCESS,
  SHOW_MIDDLE_PANEL_LOADER,
  HIDE_MIDDLE_PANEL_LOADER,
  NOTES_UPDATE_FILE_CAPTION_SUCCESS,
  UPDATE_MIDDLE_PANEL_REVIEW_SUCCESS,
  UPDATE_REFRESH_NOTE_ID,
  DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS,
  UPDATE_MIDDLE_PANEL_FILES_SUCCESS,
  SET_POST_API_ACTION_ERROR,
  RESET_POST_API_ACTION_ERROR_SUCCESS,
  ACTIVITY_NOTE_TEMPLATES_SUCCESS,
} from './actions/actionConstants';
import { ACTIVITY_LIST_PAGE_SIZE } from './constants';
import { CHANGE_ACTIVITY_OWNER_REQUEST_SUCCESS } from '../../components/ChangeOwner/actionConstants';

const middlePanelInitialState = {
  notes: {
    type: 'activity',
    skip: 0,
    take: 10,
    data: [],
    reviewFilter: '0',
    galleryData: [],
    newRecord: [],
    refreshNoteId: 0
  },
  files: {
    type: 'All',
    skip: 0,
    take: 10,
    Data: [],
    filter: {
      filterOption: ["Document", "Photo", "Audio", "Video", "Email", "Other"]
    },
    largeView: false,
    isSelectAll: false,
    galleryData: [],
    showToast: false
  },
  diaries: {
    type: 'workkard',
    skip: 0,
    take: 10,
    data: [],
    todoOwners: [],
    filter: {
      filterOption: ["ALLP"],
      sort: 'OPEN',
      todoOwners: '',
    },
    sortBy: ''
  },
  logs: {
    type: 'activity',
    skip: 0,
    take: 10,
    data: [],
    filter: {}
  },
  parties: {
    type: 'All',
    skip: 0,
    take: 15,
    data: [],
    filter: {
      filterOption: ["Workkard", "Activity"]
    },
    showToast: false
  },
  isLoading: false,
  publicApiPostError: {},
  activityNoteTemplates: {},
  excludedFilters: {}
};

const initialState = {
  associatedWorkkard: {
    take: 20,
    skip: 0,
    rows: 20,
    total: 0,
    data: [],
    filterValue: '',
    orgFilterValue: '0',
  },
  associatedWorkkardFilter: {
    data: [],
    filter: [],
  },
  contactInsured: {
    contactInsured: {},
    isLoading: false,
    errorMsg: {},
    draftIdQueue: [],
    sendVia: '',
  },
  activityListing: {
    total: 0,
    skip: 0,
    take: ACTIVITY_LIST_PAGE_SIZE,
    currentActivity: 0,
    activities: [],
    isLoader: false,
    closeActivities: [],
  },
  activityDetail: {},
  createActivity: {
    templates: [],
  },
  reOpenReasonList: {
    wrkdReOpenReasonData: {},
  },
  middlePanel: middlePanelInitialState,
};

const joinName = (first, last) => `${first || ''} ${last || ''}`.trim();

export const mapActivityListingModel = (data) => data.map((item) => ({
  activityId: item.activity_id || 0,
  activityName: item.activity_title || "",
  status: item.status || "open",
  dueDate: item.due_date,
  dueDateTz: item.due_date_tz,
  dueDateString: formatEpochAsShortDateTime(item.due_date, item.due_date_tz),
  completedDateString: item.completed_date ? formatEpochWithTimezone(item.completed_date).dateString : null,
  activityActions: item.ActivityActions || item.activityActions,
  progress: item.progress ?? item.Progress ?? 0,
  workkardId: item.workkard_id || 0,
  resolution: item.resolution || "",
  activityAssigneeId: item.activity_assignee_id || 0,
  activityOwnerId: item.activity_owner_id || 0,
  assigneeOrgId: item.assignee_org_id || 0,
  ownerOrgId: item.owner_org_id || 0,
  templateId: item.template_id || 0,
  activityAssigneeImageUrl: item.activity_assignee_image || "",
  activityOwnerImageUrl: item.activity_owner_image || "",
  createdDateString: formatEpochWithTimezone(item.created_date).dateString,
  activityOwnerUserFirstName: item.activity_owner_user_first_name || "",
  activityOwnerUserLastName: item.activity_owner_user_last_name || "",
  activityAssigneeUserFirstName: item.activity_assignee_user_first_name || "",
  activityAssigneeUserLastName: item.activity_assignee_user_last_name || "",
  activityOwnerName: joinName(item.activity_owner_user_first_name, item.activity_owner_user_last_name),
  activityAssigneeName: item.activity_assignee_user_name || joinName(item.activity_assignee_user_first_name, item.activity_assignee_user_last_name),
  assigneeOrgImage: item.assignee_org_image || "",
  assigneeOrgName: item.assignee_org_name || "",
  activityAssigneeUserName: item.activity_assignee_user_name || "",
  customFields: item.custom_fields || null,
  activityTemplateType: item.activity_template_type || null,
  skillset: item.skillset || "",
  activityDescriptionFull: item.activity_description || "",
}));

const mapAssociatedWorkkardItem = (item) => ({
  ...item,
  wkId: item.WkId,
  wkNumber: item.WkNumber,
  wkStatus: item.WkStatus,
  sponsorId: item.SponsorId,
  sponsorName: item.SponsorName,
  templateType: item.TemplateType,
  isViewable: item.IsViewable,
  fieldKey: item.FieldKey,
  fieldValue: item.FieldValue,
  dynamicFields: item.DynamicFields,
  organizationName: item.OrganizationName,
  orgId: item.OrgId,
  assigneeOrgId: item.AssigneeOrgId,
  isWorkkardClickable: item.IsWorkkardClickable,
  isSponsorActive: item.IsSponsorActive,
  profileImageUrl: item.ProfileImageURL,
});

const mapContactInsuredResponse = (raw) => {
  if (!raw || typeof raw !== 'object') {
    return raw;
  }
  return {
    ...raw,
    workkardId: raw.WorkkardId,
    customerFirstName: raw.CustomerFirstName,
    customerMiddleName: raw.CustomerMiddleName,
    customerLastName: raw.CustomerLastName,
    carrierName: raw.CarrierName,
    contactNumber: raw.ContactNumber,
    contactEmail: raw.ContactEmail,
    contactCountryCode: raw.ContactCountryCode,
    alternateCountryCode: raw.AlternateCountryCode,
    alternateContactNumber: raw.AlternateContactNumber,
    policyNumber: raw.PolicyNumber,
    licenseNumber: raw.LicenseNumber,
    userName: raw.UserName,
    phoneNumber: raw.PhoneNumber,
    workkardNumber: raw.WorkkardNumber,
    logCount: raw.logCount && {
      ...raw.logCount,
      total: raw.logCount.Total,
      text: raw.logCount.Text,
      email: raw.logCount.Email,
    },
  };
};

export const mapActivityDetailResponse = (raw) => {
  if (!raw || typeof raw !== 'object') {
    return raw;
  }
  return {
    ...raw,
    activityId: raw.ActivityId,
    workkardId: raw.WorkkardId,
    activityName: raw.ActivityName,
    activityDescriptionFull: raw.ActivityDescriptionFull,
    activityActions: raw.ActivityActions,
    activityTemplateType: raw.ActivityTemplateType,
    activityOwnerId: raw.ActivityOwnerId,
    activityOwnerName: raw.ActivityOwnerName || joinName(raw.ActivityOwnerUserFirstName, raw.ActivityOwnerUserLastName),
    activityOwnerImageUrl: raw.ActivityOwnerImageUrl,
    ownerOrgId: raw.OwnerOrgId,
    isOwnerBlocked: raw.IsOwnerBlocked,
    activityAssigneeId: raw.ActivityAssigneeId,
    activityAssignee: raw.ActivityAssignee,
    activityAssigneeName: (typeof raw.ActivityAssignee === 'string' ? raw.ActivityAssignee : null)
      || raw.ActivityAssigneeName
      || joinName(raw.ActivityAssigneeUserFirstName, raw.ActivityAssigneeUserLastName),
    activityAssigneeImageUrl: raw.ActivityAssigneeImageUrl,
    isAssigneeBlocked: raw.IsAssigneeBlocked,
    assigneeOrgId: raw.AssigneeOrgId,
    assigneeOrgName: raw.AssigneeOrgName,
    assigneeOrgImage: raw.AssigneeOrgImage,
    status: raw.Status,
    resolution: raw.Resolution,
    progress: raw.Progress,
    skillset: raw.Skillset,
    dueDate: raw.DueDate,
    dueDateTz: raw.DueDateTz,
    dueDateString: raw.DueDateString,
    activityFileCount: raw.ActivityFileCount,
    activityNoteCount: raw.ActivityNoteCount,
    activityLogCount: raw.ActivityLogCount,
    activityPartyCount: raw.ActivityPartyCount,
    activityTodos: raw.ActivityTodos,
    customFields: raw.CustomFields,
    templateId: raw.TemplateId,
  };
};

const getFileGalleryData = (records) => {
  const data = records.map((item, index) => {
    return item.Files.filter((filteredData) => filteredData.FileType == 'Image');
  });
  return data.filter(item => item && item.length > 0);
};

const applyFileCaption = (middlePanel, fid, caption) => {
  if (!fid) return;
  const patch = (file) => {
    if (file && file.FileGuid === fid) file.Caption = caption;
  };
  (middlePanel.files?.Data || []).forEach((group) => (group?.Files || []).forEach(patch));
  (middlePanel.notes?.data || []).forEach((note) => {
    (note?.ActivityNoteFiles || []).forEach(patch);
    (note?.WorkkardFiles || []).forEach(patch);
  });
  [middlePanel.files?.galleryData, middlePanel.notes?.galleryData].forEach((gallery) =>
    (gallery || []).forEach((group) => (Array.isArray(group) ? group.forEach(patch) : patch(group))));
};

const getNotesFileGalleryData = (records) => {
  const data = records.map((item, index) => {
    if (item.NoteCategory == "WorkkardNoteFile") {
      return item.WorkkardFiles.filter((filteredData) => filteredData.FileType == 'Image');
    }
    else if (item.NoteCategory == 'ActivityNote') {
      return item.ActivityNoteFiles.filter((filteredData) => filteredData.FileType == 'Image');
    }
  });
  return data.filter(item => item && item.length > 0);
};

const mergeArrayByMultipleKey = function (a, b, key1, key2) {
  if (b.length == 0) {
    return a;
  }
  var reduced = a.filter(aitem => !b.find(bitem => {
    if (aitem[key1] === bitem[key1]) {
      if (aitem[key2] === bitem[key2]) {
        return bitem;
      }
    }
    return null;
  }
  ))
  return reduced.concat(b);
};

const reconcileCustomFields = (previousFields, incomingFields) => {
  if (!Array.isArray(incomingFields) || !Array.isArray(previousFields)) return incomingFields;
  const previousByKey = new Map(previousFields.map((f) => [f.FieldKey || f.Name, f]));
  return incomingFields.map((field) => {
    if (field.Value != null) return field;
    const previous = previousByKey.get(field.FieldKey || field.Name);
    return previous && previous.Value != null ? { ...field, Value: previous.Value } : field;
  });
};

const workkardDetailSlice = createSlice({
  name: 'workkardDetail',
  initialState,
  reducers: {
    // Associated Workkard
    fetchAssociatedWorkkardRequest: () => {},
    fetchAssociatedWorkkardSuccess: (state, action) => {
      const payload = action.payload || {};
      const mappedItems = (payload.Data || []).map(mapAssociatedWorkkardItem);
      const mergedData = mergeArrayByKey(state.associatedWorkkard.data, mappedItems, 'wkId');

      state.associatedWorkkard.take = payload.take || state.associatedWorkkard.take;
      state.associatedWorkkard.skip = payload.skip || state.associatedWorkkard.skip;
      state.associatedWorkkard.rows = payload.rows || state.associatedWorkkard.rows;
      state.associatedWorkkard.total = payload.Total || state.associatedWorkkard.total;
      state.associatedWorkkard.data = mergedData;
      state.associatedWorkkard.filterValue = payload.FilterValue || state.associatedWorkkard.filterValue;

      if (payload.selectedFilter) {
        state.associatedWorkkardFilter.filter = [payload.selectedFilter];
      }
      if (payload.orgFilterValue) {
        state.associatedWorkkard.orgFilterValue = payload.orgFilterValue;
      }
    },
    fetchAssociatedWorkkardError: (state, action) => {
      Object.assign(state.associatedWorkkard, action.payload);
    },
    clearAssociatedWorkkardData: (state) => {
      state.associatedWorkkard = initialState.associatedWorkkard;
    },

    // Associated Workkard Filter
    fetchAssociatedWorkkardFilterRequest: () => {},
    fetchAssociatedWorkkardFilterSuccess: (state, action) => {
      const payload = action.payload || {};
      if (payload.Data !== undefined) state.associatedWorkkardFilter.data = payload.Data;
      if (payload.Filter !== undefined) state.associatedWorkkardFilter.filter = payload.Filter;
    },
    updateAssociatedWorkkardFilter: (state, action) => {
      const payload = action.payload || {};
      if (payload.Data !== undefined) state.associatedWorkkardFilter.data = payload.Data;
      if (payload.Filter !== undefined) state.associatedWorkkardFilter.filter = payload.Filter;
    },
    fetchAssociatedWorkkardFilterError: (state, action) => {
      state.associatedWorkkardFilter = { ...state.associatedWorkkardFilter, ...action.payload };
    },

    // Contact Insured
    fetchContactInsuredRequest: () => {},
    fetchContactInsuredSuccess: (state, action) => {
      state.contactInsured.contactInsured = mapContactInsuredResponse(action.payload);
    },
    saveContactInsuredRequest: () => {},
    contactInsuredResponseError: (state, action) => {
      state.contactInsured.errorMsg = action.payload;
    },
    saveMessageQueue: (state, action) => {
      const { Id, sendVia, type } = action.payload;
      state.contactInsured.draftIdQueue =
        type === 'push'
          ? [Id, ...state.contactInsured.draftIdQueue]
          : state.contactInsured.draftIdQueue.filter((item) => item !== Id);
      state.contactInsured.sendVia = sendVia;
    },
    resetContactInsuredDetails: (state) => {
      state.contactInsured = initialState.contactInsured;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET_WORKKARD_DETAIL_DATA, (state) => {
      state.associatedWorkkard = initialState.associatedWorkkard;
      state.activityListing = initialState.activityListing;
      state.activityDetail = initialState.activityDetail;
      state.middlePanel = middlePanelInitialState;
    });

    // Activity Listing
    builder.addCase(ACTIVITY_LISTING_SUCCESS, (state, action) => {
      const payload = action.payload || {};
      const mappedActivities = mapActivityListingModel(payload.Activities || []);
      state.activityListing.total = payload.Total;
      state.activityListing.skip = payload.skip;
      state.activityListing.take = payload.take || 10;
      state.activityListing.isLoader = false;
      state.activityListing.activities = (payload.skip || 0) === 0
        ? mappedActivities
        : mergeArrayByKey(state.activityListing.activities, mappedActivities, 'activityId');
    });

    builder.addCase(ACTIVITY_LISTING_ERROR, (state, action) => {
      Object.assign(state.activityListing, action.payload);
    });

    builder.addCase(CLOSE_ACTIVITY_LISTING_SUCCESS, (state, action) => {
      state.activityListing.closeActivities = mapActivityListingModel(action.payload.Activities);
      state.activityListing.showReopenActivityOption = action.payload.showReopenActivityOption;
    });

    builder.addCase(CLEAR_CLOSE_ACTIVITIES, (state) => {
      delete state.activityListing.showReopenActivityOption;
      state.activityListing.closeActivities = [];
    });

    builder.addCase(SET_ACTIVITY_ID, (state, action) => {
      state.activityListing.currentActivity = Number(action.payload.id) || 0;
    });

    builder.addCase(UPDATE_ACTIVITY_LISTING_SUCCESS, (state, action) => {
      const payload = action.payload || {};
      state.activityListing.total = payload.Total;
      state.activityListing.skip = payload.skip;
      state.activityListing.take = payload.take || 10;
      state.activityListing.activities = mapActivityListingModel(payload.Activities || []);
    });

    builder.addCase(SHOW_LISITNG_LOADER, (state) => {
      state.activityListing.isLoader = true;
    });

    builder.addCase(HIDE_LISITNG_LOADER, (state) => {
      state.activityListing.isLoader = false;
    });

    builder.addCase(CHANGE_ACTIVITY_OWNER_REQUEST_SUCCESS, (state, action) => {
      const { activity_id: activityId, sponser_id: sponsorId } = action.payload || {};
      const activity = state.activityListing.activities.find(
        (item) => item.activityId == activityId
      );
      if (activity) {
        activity.activityOwnerId = sponsorId;
      }
      if (state.activityDetail && state.activityDetail.activityId == activityId) {
        state.activityDetail.activityOwnerId = sponsorId;
        state.activityDetail.activityOwnerName = '';
        state.activityDetail.activityOwnerImageUrl = '';
      }
    });
    builder.addCase(UPDATE_ACTIVITY_STATUS_SUCCESS, (state, action) => {
      const activity = state.activityListing.activities.find(
        (item) => item.activityId === action.payload.ActivityId
      );
      if (activity) {
        activity.resolution = action.payload.Resolution;
        activity.status = action.payload.ResolutionForDisplay;
      }
    });

    builder.addCase(EDIT_ACTIVITY_DATA_SUCCESS, (state, action) => {
      const activity = state.activityListing.activities.find(
        (item) => item.activityId == action.payload.Id
      );
      if (activity) {
        activity.activityName = action.payload.Title;
      }
      state.activityDetail.activityName = action.payload.Title;
      state.activityDetail.activityDescriptionFull = action.payload.ActivityDesc;
    });

    // Activity Detail
    builder.addCase(ACTIVITY_DETAIL_DATA_SUCCESS, (state, action) => {
      const incomingId = action.payload?.activityId;
      const loadedId = state.activityDetail?.activityId;
      if (incomingId != null && loadedId != null && incomingId != loadedId) {
        state.activityDetail = action.payload;
      } else {
        const payload = action.payload?.customFields
          ? { ...action.payload, customFields: reconcileCustomFields(state.activityDetail.customFields, action.payload.customFields) }
          : action.payload;
        Object.assign(state.activityDetail, payload);
      }
      if (action.payload.activityId && action.payload.hasOwnProperty('progress')) {
        const activity = state.activityListing.activities.find(
          (item) => item.activityId == action.payload.activityId
        );
        if (activity) {
          activity.progress = action.payload.progress;
          if (action.payload.hasOwnProperty('resolution')) {
            activity.resolution = action.payload.resolution;
          }
        }
      }
    });

    // Switching to a different activity entirely must fully replace activityDetail rather
    // than merge, otherwise fields absent from a partial payload (e.g. the activity-listing
    // summary used as a fast-path source) silently retain the previous activity's values.
    builder.addCase(ACTIVITY_DETAIL_FULL_REPLACE, (state, action) => {
      const sameActivity = state.activityDetail?.activityId != null
        && state.activityDetail.activityId == action.payload?.activityId;
      state.activityDetail = sameActivity
        ? {
          ...action.payload,
          customFields: reconcileCustomFields(state.activityDetail.customFields, action.payload.customFields),
        }
        : action.payload;
    });

    builder.addCase(ACTIVITY_DETAIL_DATA_ERROR, (state, action) => {
      Object.assign(state.activityDetail, action.payload);
    });

    // Create Activity
    builder.addCase(FETCH_ACTIVITY_TEMPLATES_LIST_SUCCESS, (state, action) => {
      Object.assign(state.createActivity, action.payload);
    });

    // Reopen Reason List
    builder.addCase(SET_REOPEN_REASON_LIST, (state, action) => {
      state.reOpenReasonList.wrkdReOpenReasonData = action.payload;
    });

    // Middle Panel
    builder.addCase(ACTIVITY_NOTE_TEMPLATES_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, action.payload, {
        excludedFilters: { ...state.middlePanel.excludedFilters, ...action.payload.excludedFilters },
      });
    });

    builder.addCase(SET_POST_API_ACTION_ERROR, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        publicApiPostError: { ...state.middlePanel.publicApiPostError, [action.payload.type]: action.payload[action.payload.type] },
      });
    });

    builder.addCase(RESET_POST_API_ACTION_ERROR_SUCCESS, (state) => {
      state.middlePanel = Object.assign({}, state.middlePanel, { publicApiPostError: {} });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_DATA_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, action.payload);
    });

    builder.addCase(FETCH_MIDDLE_PANEL_FILTER_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, action.payload);
    });

    builder.addCase(FETCH_MIDDLE_PANEL_NOTES_SUCCESS, (state, action) => {
      const isFirstPage = (action.payload.notes.skip || 0) === 0;
      const notesData = isFirstPage
        ? action.payload.notes.data
        : mergeArrayByKey(state.middlePanel.notes.data, action.payload.notes.data, 'Id');
      const notesDataObj = {
        notes: {
          type: state.middlePanel.notes.type,
          skip: action.payload.notes.skip,
          take: action.payload.notes.take,
          total: action.payload.notes.total,
          reviewFilter: action.payload.notes.reviewFilter ? action.payload.notes.reviewFilter : middlePanelInitialState.notes.reviewFilter,
          data: notesData,
          newRecord: [],
          refreshNoteId: 0,
        },
        excludedFilters: { ...state.middlePanel.excludedFilters, ...action.payload.excludedFilters },
      };
      const galleryData = getNotesFileGalleryData(notesData);
      notesDataObj.notes.galleryData = isFirstPage
        ? galleryData
        : [].concat(state.middlePanel.notes.galleryData || [], galleryData);
      state.middlePanel = Object.assign({}, state.middlePanel, notesDataObj);
    });

    builder.addCase(UPDATE_MIDDLE_PANEL_NOTES_SUCCESS, (state, action) => {
      let notesData = [];
      let galleryData = [];
      let newRecords = [];
      const existingIds = state.middlePanel.notes.data.map(x => x.Id);
      if (existingIds.length > 0) {
        newRecords = action.payload.notes.data.filter(data => !existingIds.includes(data.Id));
        notesData = newRecords.length > 0 ? [].concat(newRecords, state.middlePanel.notes.data) : action.payload.notes.data;
        galleryData = getNotesFileGalleryData(action.payload.notes.data);
        galleryData = newRecords.length > 0 ? [].concat(galleryData, state.middlePanel.notes.galleryData || []) : galleryData;
      } else {
        notesData = [].concat(state.middlePanel.notes.data, action.payload.notes.data);
        galleryData = [].concat(state.middlePanel.notes.galleryData || [], getNotesFileGalleryData(action.payload.notes.data));
      }
      const notesDataObj = {
        notes: {
          type: state.middlePanel.notes.type,
          skip: action.payload.notes.skip,
          take: action.payload.notes.take,
          total: action.payload.notes.total,
          reviewFilter: action.payload.notes.reviewFilter ? action.payload.notes.reviewFilter : middlePanelInitialState.notes.reviewFilter,
          data: notesData,
          galleryData: galleryData,
          newRecord: newRecords,
        },
      };
      state.middlePanel = Object.assign({}, state.middlePanel, notesDataObj);
    });

    builder.addCase(REMOVE_EDITED_NOTE, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        notes: Object.assign({}, state.middlePanel.notes, {
          data: state.middlePanel.notes.data.filter(item => item.Id != action.payload.nId),
        }),
      });
    });

    builder.addCase(UPDATE_MIDDLE_PANEL_FILES_SUCCESS, (state, action) => {
      let filesData = [];
      let galleryData = [];
      const existingIds = state.middlePanel.files.Data.map(x => x.Id);
      if (existingIds.length > 0) {
        const newRecords = action.payload.files.Data.filter(data => !existingIds.includes(data.Id));
        filesData = newRecords.length > 0 ? [].concat(newRecords, state.middlePanel.files.Data) : action.payload.files.Data;
        galleryData = getFileGalleryData(action.payload.files.Data);
        galleryData = newRecords.length > 0 ? [].concat(galleryData, state.middlePanel.files.galleryData || []) : galleryData;
      } else {
        filesData = [].concat(state.middlePanel.files.Data, action.payload.files.Data);
        galleryData = [].concat(state.middlePanel.files.galleryData || [], galleryData);
      }
      const filesDataObj = {
        files: {
          type: state.middlePanel.files.type,
          skip: action.payload.files.skip,
          take: action.payload.files.take,
          total: action.payload.files.total,
          filter: {
            filterOption: ["Document", "Photo", "Audio", "Video", "Email", "Other"],
          },
          largeView: false,
          isSelectAll: false,
          Data: filesData,
          galleryData,
          showToast: action.payload.showToast || middlePanelInitialState.files.showToast,
        },
      };
      state.middlePanel = Object.assign({}, state.middlePanel, filesDataObj);
    });

    builder.addCase(UPDATE_MIDDLE_PANEL_PARTIES_SUCCESS, (state, action) => {
      const partiesData = mergeArrayByMultipleKey(action.payload.parties.data, state.middlePanel.parties.data, 'id', 'entityId');
      state.middlePanel = Object.assign({}, state.middlePanel, {
        parties: {
          type: action.payload.parties.type,
          skip: action.payload.parties.skip,
          take: action.payload.parties.take,
          data: partiesData,
          filter: state.middlePanel.parties.filter,
          total: action.payload.parties.total,
        },
      });
    });

    builder.addCase(UPDATE_MIDDLE_PANEL_LOG_SUCCESS, (state, action) => {
      let logsData = [];
      const existingIds = state.middlePanel.logs.data.map(x => x.KeyObject.Id);
      if (existingIds.length > 0) {
        logsData = mergeArrayByKey(action.payload.logs.data, state.middlePanel.logs.data, "key");
        logsData = sortArrayByKey(logsData, "key", "desc");
      } else {
        logsData = [].concat(state.middlePanel.logs.data, action.payload.logs.data);
      }
      const logs = Object.assign({}, state.middlePanel.logs, {
        data: logsData,
        total: action.payload.logs.total,
        skip: action.payload.logs.skip || state.middlePanel.logs.skip,
        take: action.payload.logs.take || state.middlePanel.logs.take,
      });
      state.middlePanel = Object.assign({}, state.middlePanel, { logs: logs });
    });

    builder.addCase(UPDATE_MIDDLE_PANEL_REVIEW_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, action.payload);
    });

    builder.addCase(UPDATE_REFRESH_NOTE_ID, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        notes: Object.assign({}, state.middlePanel.notes, { refreshNoteId: action.payload.id }),
      });
    });

    builder.addCase(NOTES_ACTION_PUBLISH_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        notes: Object.assign({}, state.middlePanel.notes, {
          data: state.middlePanel.notes.data.map((data) => {
            if (data.Id == action.payload.id) {
              return Object.assign({}, data, { ...action.payload });
            }
            return data;
          }),
        }),
      });
    });

    builder.addCase(NOTES_ACTION_DELETE_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        notes: Object.assign({}, state.middlePanel.notes, {
          data: state.middlePanel.notes.data.filter(item => item.Id != action.payload.nId),
          total: state.middlePanel.notes.total > 0 ? state.middlePanel.notes.total - 1 : 0,
        }),
      });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_FILE_SUCCESS, (state, action) => {
      const filesData = action.payload;
      const galleryData = getFileGalleryData(filesData.files.Data);
      filesData.files.galleryData = filesData.files.skip
        ? [].concat(state.middlePanel.files.galleryData || [], galleryData)
        : galleryData;
      state.middlePanel = Object.assign({}, state.middlePanel, action.payload, filesData);
    });

    builder.addCase(FETCH_MIDDLE_PANEL_LOG_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        logs: {
          type: action.payload.log.type,
          skip: action.payload.log.skip,
          take: action.payload.log.take,
          total: action.payload.log.total,
          data: action.payload.log.data,
        },
      });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_DIARIES_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        diaries: {
          type: action.payload.diaries.type,
          skip: action.payload.diaries.skip,
          take: action.payload.diaries.take,
          total: action.payload.diaries.total,
          todoOwners: action.payload.diaries.todoOwners || [],
          filter: action.payload.diaries.filter || middlePanelInitialState.diaries.filter,
          data: [].concat(state.middlePanel.diaries.data, action.payload.diaries.data),
          sortBy: action.payload.diaries.sortBy || middlePanelInitialState.diaries.sortBy,
        },
      });
    });

    builder.addCase(WORKKARD_TODO_OWNERS_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        diaries: {
          type: action.payload.diaries.type,
          skip: state.middlePanel.diaries.skip,
          take: state.middlePanel.diaries.take,
          total: state.middlePanel.diaries.total,
          todoOwners: action.payload.diaries.todoOwners || [],
          filter: state.middlePanel.diaries.filter || middlePanelInitialState.diaries.filter,
          data: state.middlePanel.diaries.data,
          sortBy: action.payload.diaries.sortBy || middlePanelInitialState.diaries.sortBy,
        },
      });
    });

    builder.addCase(DIARIES_TITLE_EDIT_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        diaries: Object.assign({}, state.middlePanel.diaries, {
          data: state.middlePanel.diaries.data.map((data) => {
            if (data.TodoId == action.payload.todoId) {
              return Object.assign({}, data, { Title: action.payload.title });
            }
            return data;
          }),
        }),
      });
    });

    builder.addCase(DIARIES_DUE_DATE_EDIT_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        diaries: Object.assign({}, state.middlePanel.diaries, {
          data: state.middlePanel.diaries.data.map((data) => {
            if (data.TodoId == action.payload.cid) {
              return Object.assign({}, data, { DueOn: action.payload.dueOn, DueDate: action.payload.DueDate });
            }
            return data;
          }),
        }),
      });
    });

    builder.addCase(DIARIES_ACTION_COMPLETE_SUCCESS, (state, action) => {
      const status = action.payload.isComplete.trim() == 'true' ? 'COMPLETED' : 'OPEN';
      const completed = action.payload.isComplete.trim() == 'true' ? true : false;
      state.middlePanel = Object.assign({}, state.middlePanel, {
        diaries: Object.assign({}, state.middlePanel.diaries, {
          data: (state.middlePanel.diaries.filter.sort == "ALL") ?
            state.middlePanel.diaries.data.map((data) => {
              if (data.TodoId == action.payload.id) {
                if (action.data) {
                  return Object.assign({}, data, action.data[0]);
                } else {
                  return Object.assign({}, data, { IsCompleted: completed, Status: status });
                }
              }
              return data;
            })
            :
            state.middlePanel.diaries.data.filter(item => item.TodoId != action.payload.id),
        }, {
          total: (state.middlePanel.diaries.filter.sort == "ALL") ? state.middlePanel.diaries.total : state.middlePanel.diaries.total - 1,
        }),
      });
    });

    builder.addCase(DIARIES_ACTION_CANCELLED_SUCCESS, (state, action) => {
      const status = "CANCELLED";
      state.middlePanel = Object.assign({}, state.middlePanel, {
        diaries: Object.assign({}, state.middlePanel.diaries, {
          data: (state.middlePanel.diaries.filter.sort == "ALL") ?
            state.middlePanel.diaries.data.map((data) => {
              if (data.TodoId == action.payload.id) {
                return Object.assign({}, data, { IsCancelled: true, Status: status, IsEditable: false });
              }
              return data;
            })
            :
            state.middlePanel.diaries.data.filter(item => item.TodoId != action.payload.id),
        }, {
          total: (state.middlePanel.diaries.filter.sort == "ALL") ? state.middlePanel.diaries.total : state.middlePanel.diaries.total - 1,
        }),
      });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_PARTIES_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        parties: {
          type: action.payload.parties.type,
          skip: action.payload.parties.skip,
          take: action.payload.parties.take,
          total: action.payload.parties.total,
          filter: action.payload.parties.filter || middlePanelInitialState.parties.filter,
          data: [].concat(state.middlePanel.parties.data, action.payload.parties.data),
          showToast: action.payload.showToast || middlePanelInitialState.parties.showToast,
        },
      });
    });

    builder.addCase(RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS, (state) => {
      state.middlePanel = Object.assign({}, {
        ...middlePanelInitialState,
        notes: { ...middlePanelInitialState.notes },
        activityNoteTemplates: state.middlePanel.activityNoteTemplates,
        excludedFilters: state.middlePanel.excludedFilters,
        activeTab: state.middlePanel.activeTab || 0,
      });
    });

    builder.addCase(RESET_MIDDLE_PANEL_INDIVIDUAL_TAB_SUCCESS, (state, action) => {
      switch (action.payload.type) {
        case 'notes': {
          state.middlePanel = Object.assign({}, state.middlePanel, {
            notes: {
              type: action.payload.value,
              skip: middlePanelInitialState.notes.skip,
              take: middlePanelInitialState.notes.take,
              total: state.middlePanel.notes.total,
              reviewFilter: action.payload.reviewFilter || middlePanelInitialState.notes.reviewFilter,
              data: middlePanelInitialState.notes.data,
              newRecord: middlePanelInitialState.notes.newRecord,
              galleryData: middlePanelInitialState.notes.galleryData,
            },
          });
          break;
        }
        case 'files': {
          state.middlePanel = Object.assign({}, state.middlePanel, {
            files: {
              type: action.payload.value,
              skip: middlePanelInitialState.files.skip,
              take: middlePanelInitialState.files.take,
              Data: middlePanelInitialState.files.Data,
              largeView: state.middlePanel.files.largeView,
              isSelectAll: middlePanelInitialState.files.isSelectAll,
              galleryData: middlePanelInitialState.files.galleryData,
              filter: action.payload.filter || middlePanelInitialState.files.filter,
              showToast: action.payload.showToast || middlePanelInitialState.files.showToast,
            },
          });
          break;
        }
        case 'logs': {
          state.middlePanel = Object.assign({}, state.middlePanel, {
            logs: {
              type: action.payload.value,
              skip: middlePanelInitialState.logs.skip,
              take: middlePanelInitialState.logs.take,
              data: middlePanelInitialState.logs.data,
            },
          });
          break;
        }
        case 'diaries': {
          let filter = middlePanelInitialState.diaries.filter;
          if (action.payload.filter) {
            filter = Object.assign({}, state.middlePanel.diaries.filter, {
              filterOption: [].concat(action.payload.filter.filterOption),
              sort: action.payload.filter.sort,
              todoOwners: action.payload.filter.todoOwners.toString(),
            });
          }
          state.middlePanel = Object.assign({}, state.middlePanel, {
            diaries: {
              type: action.payload.value,
              skip: middlePanelInitialState.diaries.skip,
              take: middlePanelInitialState.diaries.take,
              total: action.payload.total,
              todoOwners: action.payload.todoOwners || middlePanelInitialState.diaries.todoOwners,
              filter,
              data: middlePanelInitialState.diaries.data,
              sortBy: action.payload.sortBy || middlePanelInitialState.diaries.sortBy,
            },
          });
          break;
        }
        case 'parties': {
          state.middlePanel = Object.assign({}, state.middlePanel, {
            parties: {
              type: action.payload.value,
              skip: middlePanelInitialState.parties.skip,
              take: middlePanelInitialState.parties.take,
              data: middlePanelInitialState.parties.data,
              filter: action.payload.filter || middlePanelInitialState.parties.filter,
              showToast: action.payload.showToast || middlePanelInitialState.files.showToast,
            },
          });
          break;
        }
        default:
          break;
      }
    });

    builder.addCase(UPDATE_CAPTION_SUCCESS, (state, action) => {
      const { fid, caption } = action.payload;
      applyFileCaption(state.middlePanel, fid, caption);
    });

    builder.addCase(NOTES_UPDATE_FILE_CAPTION_SUCCESS, (state, action) => {
      const { fid, caption } = action.payload;
      applyFileCaption(state.middlePanel, fid, caption);
    });

    builder.addCase(IS_LARGE_VIEW_ACTIVE, (state, action) => {
      const largeViewUpdate = Object.assign({}, state.middlePanel.files, { largeView: action.payload });
      state.middlePanel = Object.assign({}, state.middlePanel, { files: largeViewUpdate });
    });

    builder.addCase(IS_SELECT_ALL, (state, action) => {
      const selectAllUpdate = Object.assign({}, state.middlePanel.files, { isSelectAll: action.payload });
      state.middlePanel = Object.assign({}, state.middlePanel, { files: selectAllUpdate });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_NOTES_ERROR, (state, action) => {
      const notes = Object.assign({}, state.middlePanel.notes, action.payload);
      state.middlePanel = Object.assign({}, state.middlePanel, { notes: notes });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_FILE_ERROR, (state, action) => {
      const files = Object.assign({}, state.middlePanel.files, action.payload);
      state.middlePanel = Object.assign({}, state.middlePanel, { files: files });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_DIARIES_ERROR, (state, action) => {
      const diaries = Object.assign({}, state.middlePanel.diaries, action.payload);
      state.middlePanel = Object.assign({}, state.middlePanel, { diaries: diaries });
    });

    builder.addCase(FETCH_MIDDLE_PANEL_LOG_ERROR, (state, action) => {
      const logs = Object.assign({}, state.middlePanel.logs, action.payload);
      state.middlePanel = Object.assign({}, state.middlePanel, { logs: logs });
    });

    builder.addCase(DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS, (state, action) => {
      state.middlePanel = Object.assign({}, state.middlePanel, {
        parties: Object.assign({}, state.middlePanel.parties, {
          data: state.middlePanel.parties.data.filter(item =>
            (item.Id != action.payload.pid) ?
              item
              :
              (
                (item.entityId != action.payload.eid) ?
                  item : null
              )
          ),
          total: state.middlePanel.parties.total - 1,
        }),
      });
    });

    builder.addCase(SHOW_MIDDLE_PANEL_LOADER, (state) => {
      state.middlePanel = Object.assign({}, state.middlePanel, { isLoading: true });
    });

    builder.addCase(HIDE_MIDDLE_PANEL_LOADER, (state) => {
      state.middlePanel = Object.assign({}, state.middlePanel, { isLoading: false });
    });
  },
});

export const {
  fetchAssociatedWorkkardRequest,
  fetchAssociatedWorkkardSuccess,
  fetchAssociatedWorkkardError,
  clearAssociatedWorkkardData,
  fetchAssociatedWorkkardFilterRequest,
  fetchAssociatedWorkkardFilterSuccess,
  updateAssociatedWorkkardFilter,
  fetchAssociatedWorkkardFilterError,
  fetchContactInsuredRequest,
  fetchContactInsuredSuccess,
  saveContactInsuredRequest,
  contactInsuredResponseError,
  saveMessageQueue,
  resetContactInsuredDetails,
} = workkardDetailSlice.actions;

export default workkardDetailSlice.reducer;

export const selectAssociatedWorkkard = (state) => state.workkardDetail.associatedWorkkard;
export const selectAssociatedWorkkardFilter = (state) => state.workkardDetail.associatedWorkkardFilter;
export const selectContactInsured = (state) => state.workkardDetail.contactInsured;
export const selectActivityListing = (state) => state.workkardDetail.activityListing;
export const selectActivityDetail = (state) => state.workkardDetail.activityDetail;
export const selectCreateActivity = (state) => state.workkardDetail.createActivity;
export const selectReOpenReasonList = (state) => state.workkardDetail.reOpenReasonList;
export const selectMiddlePanel = (state) => state.workkardDetail.middlePanel;
